<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Greetings - Change Order</div>
                  <p>You can change Greeting list ordering by drag and drop !</p>
                </div>
              <div class="col-md-2 offset-md-3 text-right center">
                <router-link to="/admin/greetings" class="btn btn-primary" role="button">
                  back
                </router-link>
              </div>
            </div>

          <div class="table-responsive text-center">
            <table class="table table-light table-bordered table-hover">
              <draggable v-model="greetings.data" @start="drag=true" @end="drag=false">
                <tr v-for="(item, index) in greetings.data" :key="index">
                  <!--<td>{{item.displayOrder}}</td>-->
                  <td>{{item.bannerMessage}}</td>
                  <td>{{item.destinationURL}}</td>
                  <td>{{item.corporationName}}</td>
                  <td>{{item.start_dateFmt}}</td>
                  <td>{{item.end_dateFmt}}</td>
                  <td>
                    <span class="badge badge-success" v-if="item.active != '0'"> Active </span>
                    <span class="badge badge-danger" v-else> Inactive </span>
                  </td>
                </tr>
              </draggable>
            </table>
          </div>

          <div class="offset-md-3 col-md-6 text-center">
            <button class="btn btn-primary btn-fill btn-block" @click="updateGreetingListing">
              Update listings order
            </button>
          </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    import draggable from 'vuedraggable'
    const greetingsColumns = ['Message', 'URL', 'Corporation Name','Start Date/Time', 'End Date/Time','Status', 'Operations'];
    export default {
        name: 'GreetingOrder',
        components: {
            LTable,
            draggable,
        },
        data() {
        return {
            greetings: {
        data: []
    }
    }
    },
    methods: {
      updateGreetingListing () {
          let data = this.greetings.data;
          let greetingsIds = data.map((obj) => {
            return obj.bannerId
          });
          this.$store.dispatch('UPDATE_GREETINGS_ORDERING', {dispOrderBannerIds: greetingsIds})
            .then((res) => {
              console.log("UPDATE_EXPERTS_ORDERING API res : ", res);
              this.$swal('Success!', 'Display order updated successfully', 'success');
              this.$router.push('/admin/greetings')
            })
            .catch(err => {
              console.log("UPDATE_EXPERTS_ORDERING API error : ", err);
            })
        },
      fetchGreetings () {
        this.$store.dispatch('FETCH_GREETINGS')
          .then((res) => {
            console.log('res', res)
            this.greetings.data = res;
          })
          .catch(err => {
            console.log("API error : ", err);
          })
          , (err) => {
          console.log("err : ", err);
        }
      },
    },
    created() {
        this.fetchGreetings();
    }
    }
</script>

<style>
    .btn-icon{
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Greetings/OrderGreetings.vue